import { createAsyncThunk } from '@reduxjs/toolkit'
import MobileCredentials from './mobile-credentials-model'
import {
  delete_mobileCredentials,
  load_mobileCredentialss,
  store_mobileCredentials,
} from './mobileCredentials-service'

export const LoadMobileCredentialssAsync = createAsyncThunk<any, any>(
  'composer/load/mobileCredentials',
  async (params: { uid: string }) => {
    return await load_mobileCredentialss(params)
  },
)

export const CreateMobileCredentialsAsync = createAsyncThunk<any, any>(
  'composer/create/mobileCredentials',
  async (params: MobileCredentials) => {
    return await store_mobileCredentials(params)
  },
)

export const DeleteMobileCredentialsAsync = createAsyncThunk<any, any>(
  'composer/delete/mobileCredentials',
  async (params) => {
    return await delete_mobileCredentials(params)
  },
)
